import { Anchor, Breadcrumbs, Group, Text } from '@mantine/core'
import { PropsWithChildren } from 'react'
import { Helmet } from 'components/common/Helmet'
import { TbChevronsRight, TbHome } from 'react-icons/tb'
import { Link, To } from 'react-router-dom'
import { capitalizeFirstLetter } from 'shared/utils'

export type BreadcrumbItem = {
  title: string
  href?: To
}

type BreadcrumbProps = {
  items: BreadcrumbItem[]
  homeLink?: To
}

export const Breadcrumb = ({
  items,
  children,
  homeLink,
}: PropsWithChildren<BreadcrumbProps>) => {
  const title = items.length === 0 ? null : items[items.length - 1].title

  return (
    <>
      {title && (
        <Helmet>
          <title>{capitalizeFirstLetter(title)} | Connected Life</title>
        </Helmet>
      )}
      <Group gap={'xl'} justify="space-between" align="center">
        <Breadcrumbs
          style={{
            maxWidth:
              'calc(100vw - var(--mantine-spacing-lg) - var(--mantine-spacing-lg))',
            overflow: 'hidden',
          }}
          separator={<TbChevronsRight color="currentColor" size="1em" />}
        >
          <Anchor component={Link} to={homeLink ?? '/'}>
            <TbHome color="currentColor" size="1.2rem" />
          </Anchor>
          {items.map((item, index) =>
            item.href ? (
              <Anchor key={index} component={Link} to={item.href}>
                {capitalizeFirstLetter(item.title)}
              </Anchor>
            ) : (
              <Text key={index}>{capitalizeFirstLetter(item.title)}</Text>
            ),
          )}
        </Breadcrumbs>
        <Group gap={'md'} justify="right">
          {children}
        </Group>
      </Group>
    </>
  )
}
